import script from "./DocItemCheckSN.vue?vue&type=script&setup=true&lang=js"
export * from "./DocItemCheckSN.vue?vue&type=script&setup=true&lang=js"

import "./DocItemCheckSN.vue?vue&type=style&index=0&id=5adee75e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5adee75e"]])

export default __exports__